module.exports = __webpack_public_path__ + "static/media/video.413f7861.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/PrinceHotel/video.mp4
// module id = 249
// module chunks = 0